import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import { getNotificacoesUsuario, changeNotificacao, init } from './notificacoesUsuarioActions';
import LabelAndInput from '../common/form/labelAndInput';
import Button from '../common/form/button';

import ToggleSwitch from '../common/form/ToggleSwitch';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import LabelAndSelectForm from '../common/form/labelAndSelectForm';

class UsuarioNotificacoesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.id,
      filtrar_notificacao: this.props.filtrar_notificacao,
      alerta_tela: this.props.alerta_tela,
      notificacoes: [],
      modificado: false,
      searchTerm: '',
      selectedFirst: true,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.notificacoes.length === 0 && nextProps.notificacoes.length > 0 && !prevState.modificado) {
      let notificacaoesSelecionadasIds = nextProps.notificacoes
        .filter(notificacao => notificacao.selecionado > 0)
        .map(notificacao => notificacao.id);
      if (notificacaoesSelecionadasIds.length === 0) {
        notificacaoesSelecionadasIds = nextProps.notificacoes.map(notificacao => notificacao.id);
      }
      return {
        notificacoes: notificacaoesSelecionadasIds,
      };
    }
    return null;
  }

  handleOnChange = event => {
    const notificacoes = this.state.notificacoes;
    const id = parseInt(event.target.id);
    this.setState({ modificado: true });
    if (!notificacoes.includes(id)) {
      notificacoes.push(id);
    } else {
      notificacoes.splice(notificacoes.indexOf(id), 1);
    }
    this.setState({ notificacoes });
  };

  handleToggleNotificacao = id => {
    const notificacoes = this.state.notificacoes;
    const parsedId = parseInt(id);
    this.setState({ modificado: true });
    if (!notificacoes.includes(parsedId)) {
      notificacoes.push(parsedId);
    } else {
      notificacoes.splice(notificacoes.indexOf(parsedId), 1);
    }
    this.setState({ notificacoes });
  };

  handleOnChangeFiltrar = event => {
    this.setState({ filtrar_notificacao: parseFloat(event.target.value) });
  };

  handleOnChangeAlertaTela = event => {
    this.setState({ alerta_tela: parseFloat(event.target.value) });
  };

  handleSearchChange = event => {
    this.setState({ searchTerm: event.target.value || '' });
  };

  handleSelecionarTodas = () => {
    const notificacoes = (this.props.notificacoes || []).map(n => n.id);
    this.setState({ notificacoes, modificado: true });
  };

  handleLimparSelecao = () => {
    this.setState({ notificacoes: [], modificado: true });
  };

  handleToggleSelectedFirst = () => {
    this.setState(prev => ({ selectedFirst: !prev.selectedFirst }));
  };

  handleOnSubmit = event => {
    event.preventDefault();
    const selecionouTodas = this.state.notificacoes.length === this.props.notificacoes.length;
    this.props.changeNotificacao({
      id: this.state.id,
      filtrar_notificacao: this.state.filtrar_notificacao,
      alerta_tela: this.state.alerta_tela,
      notificacoes: selecionouTodas ? [] : this.state.notificacoes,
    });
  };

  render() {
    const premiumForm = this.props.premiumLayout === true;
    const notificacoes = this.props.notificacoes || [];
    const selecionadasCount = this.state.notificacoes.length;
    const totalCount = notificacoes.length;

    const term = (this.state.searchTerm || '').trim().toLowerCase();
    const notificacoesFiltradas = term
      ? notificacoes.filter(n => {
          const idNum = n.id;
          const idStr = String(idNum || '');
          const idStr2 = String(idNum || '').padStart(2, '0');
          const idStr3 = String(idNum || '').padStart(3, '0');
          const desc = String(n.descricao || '');
          const descMatch = desc.toLowerCase().includes(term);
          const idMatch = idStr.includes(term) || idStr2.includes(term) || idStr3.includes(term);
          return idMatch || descMatch;
        })
      : notificacoes;

    const notificacoesOrdenadas = [...notificacoesFiltradas].sort((a, b) => {
      if (!this.state.selectedFirst) {
        return (a.id || 0) - (b.id || 0);
      }
      const aSel = this.state.notificacoes.includes(a.id) ? 1 : 0;
      const bSel = this.state.notificacoes.includes(b.id) ? 1 : 0;
      if (aSel !== bSel) return bSel - aSel;
      return (a.id || 0) - (b.id || 0);
    });

    const filtrarTooltip = (
      <OverlayTrigger
        placement="top"
        delayShow={300}
        delayHide={150}
        overlay={
          <Tooltip id="tooltip">
            Ao ativar, o popup de notificações exibirá apenas os tipos de erro selecionados abaixo. As telas de listagem
            de erros continuam mostrando todos os registros.
          </Tooltip>
        }
      >
        <i className={`fa fa-question-circle`} />
      </OverlayTrigger>
    );

    const alertaEmTelaTooltip = (
      <OverlayTrigger
        placement="top"
        delayShow={300}
        delayHide={150}
        overlay={<Tooltip id="tooltip">Ao ativar, as listagens de erros deverão ser exibidas em tela.</Tooltip>}
      >
        <i className={`fa fa-question-circle`} />
      </OverlayTrigger>
    );

    return (
      <form onSubmit={this.handleOnSubmit} className={premiumForm ? 'simple-cad-form-premium' : ''}>
        <div className={premiumForm ? 'simple-cad-premium-container' : 'box-body'}>
          <div className={premiumForm ? 'simple-cad-premium-card' : ''}>
            {premiumForm && (
              <div className="simple-cad-premium-header">
                <h4>
                  <i className="fa fa-bell" /> Notificações do Usuário
                </h4>
                <p>Defina quais alertas serão exibidos para este usuário.</p>
              </div>
            )}
            <div className={premiumForm ? 'simple-cad-premium-body usuario-notificacoes-premium-body' : ''}>
              <Field
                name="nome"
                component={LabelAndInput}
                readOnly={true}
                label="Nome"
                cols={premiumForm ? '12 6' : '12'}
                placeholder="Automático"
              />
              {premiumForm && <div className="clearfix" />}

              <Field
                name="filtrar_notificacao"
                component={LabelAndSelectForm}
                cols={premiumForm ? '12 6' : undefined}
                label={
                  <>
                    <span style={{ marginRight: '3px' }}>Filtrar erros na listagem</span>
                    {filtrarTooltip}
                  </>
                }
                onChange={this.handleOnChangeFiltrar}
              >
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </Field>

              <Field
                name="alerta_tela"
                component={LabelAndSelectForm}
                cols={premiumForm ? '12 6' : undefined}
                label={
                  <>
                    <span style={{ marginRight: '3px' }}>Exibir alertas em tela</span>
                    {alertaEmTelaTooltip}
                  </>
                }
                onChange={this.handleOnChangeAlertaTela}
              >
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </Field>

              <div className={premiumForm ? 'usuario-notificacoes-premium-section' : 'form-group'}>
                <div style={premiumForm ? { marginTop: 4 } : { marginLeft: 15, marginTop: 15 }}>
                  <label className="control-label">Notificações a serem mostradas</label>
                  <p>
                    <small>
                      Selecione as notificações que deseja que sejam mostradas para este usuário. Por padrão, todas as
                      notificações são mostradas.
                    </small>
                  </p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', marginTop: 10 }}>
                    <div style={{ flex: '1 1 280px', minWidth: 220 }}>
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.searchTerm}
                        onChange={this.handleSearchChange}
                        placeholder="Buscar por código (ex: 60) ou descrição (ex: Porta)"
                      />
                    </div>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                      <button type="button" className="btn btn-default btn-sm" onClick={this.handleSelecionarTodas}>
                        Selecionar todas
                      </button>
                      <button type="button" className="btn btn-default btn-sm" onClick={this.handleLimparSelecao}>
                        Limpar seleção
                      </button>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontSize: 12, opacity: 0.85 }}>Selecionadas primeiro</span>
                      <ToggleSwitch
                        isOn={this.state.selectedFirst}
                        onToggle={this.handleToggleSelectedFirst}
                        size="small"
                        onColor="#3c8dbc"
                        offColor="#6c757d"
                      />
                    </div>
                    <div style={{ marginLeft: 'auto', fontSize: 12, opacity: 0.85 }}>
                      {selecionadasCount}/{totalCount} selecionadas
                    </div>
                  </div>
                </div>
                <div style={premiumForm ? { marginTop: 10 } : { paddingLeft: 15, paddingRight: 15, marginTop: 10 }}>
                  <div className="row">
                    {notificacoesOrdenadas.map((notificacao, index) => {
                      const isOn = this.state.notificacoes.includes(notificacao.id);
                      const codigo = String(notificacao.id).padStart(2, '0');
                      return (
                        <div
                          key={`${notificacao.id}-${index}`}
                          className="col-xs-12 col-md-6 col-lg-4"
                          style={{ paddingLeft: 6, paddingRight: 6 }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              padding: '7px 10px',
                              border: '1px solid rgba(0,0,0,0.08)',
                              borderRadius: 8,
                              marginBottom: 8,
                              background: isOn ? 'rgba(60,141,188,0.06)' : '#fff',
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, minWidth: 0 }}>
                              <span
                                style={{ fontFamily: 'monospace', opacity: 0.75, minWidth: 28, textAlign: 'right' }}
                              >
                                {codigo}
                              </span>
                              <span
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  fontSize: 13,
                                  lineHeight: '16px',
                                }}
                              >
                                {notificacao.descricao}
                              </span>
                            </div>
                            <ToggleSwitch
                              isOn={isOn}
                              onToggle={() => this.handleToggleNotificacao(notificacao.id)}
                              size="small"
                              onColor="#28a745"
                              offColor="#dc3545"
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={premiumForm ? 'simple-cad-premium-footer' : 'box-footer '}>
          <Button type="submit" className={this.props.submitClass} icon="check" label={this.props.submitLabel} />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

UsuarioNotificacoesForm = reduxForm({ form: 'usuarioNotificacoesForm', destroyOnUnmount: true })(
  UsuarioNotificacoesForm,
);
const selector = formValueSelector('usuarioNotificacoesForm');
const mapDispatchToProps = dispatch =>
  bindActionCreators({ init, getNotificacoesUsuario, changeNotificacao }, dispatch);
export default connect(
  state => ({
    id: selector(state, 'id'),
    filtrar_notificacao: selector(state, 'filtrar_notificacao'),
    alerta_tela: selector(state, 'alerta_tela'),
    notificacoes: state.notificacoesList.list,
  }),
  mapDispatchToProps,
)(UsuarioNotificacoesForm);
